import { useQuery } from '@tanstack/react-query'
import { logSentryError } from '@node-space/utils'
import { reactQueryKeys } from 'reactQueryKeys/reactQueryKeys'
import { getWalletsV2 } from 'services/WalletsService'
import { TWalletType } from 'types/wallets'

export const useWalletsQueryV2 = ({
  walletType,
  searchTerm,
  offset,
  max,
}: {
  walletType: TWalletType
  searchTerm?: string
  offset?: number
  max?: number
}) => {
  return useQuery(
    reactQueryKeys.walletsV2(walletType, searchTerm, offset, max),
    () => getWalletsV2(walletType, searchTerm, offset, max),
    {
      refetchOnWindowFocus: false,
      onError: error => logSentryError('Error from useWalletsQueryV2 - getWalletsV2', error),
    }
  )
}
